import {TABS} from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';
import notFound from '../../../../../assets/images/not-found.png';
import ProductsSelector from '../components/ProductsSelector';

export default function formProductDetail(currentLang, categories, customAttributes, metaAttributes, imageAttributes, categoriesSelected, allGroups, errors, seeErrors,handleMediaPicker, imagesSelected,variantGroup, handleToggleDrawer, variantsValidated, allowedTypes, hasPrice,currentCollection,mediaCategories,selectedMediaCategories,allState) {
    let typeInput = '';    
    let attributeSetup = attribute => {
        let isMeta = attribute.node.identifier.indexOf('meta') > -1
        let isMediaCategory = false;    
        let isEmail = false;
        const defaultLang = attribute.node.translation.translationDatas.edges[0];
        // console.log(allState)
        const langSelected = attribute.node.translation.translationDatas.edges.find(
            lang => lang.node.locale.code === currentLang
        );
        switch(attribute.node.attributeType.input) {
            case 'textarea':
                typeInput = isMeta? 'textareaSimple' : 'textarea';
                break;
            case 'number': 
            case 'decimal': 
                typeInput = 'decimal';
                break;
            case 'text':
                typeInput = 'text';
                break;
            case 'mail':
                typeInput = 'text';
                isEmail = true;
                break;
            case 'link':
                typeInput = 'text';
                break;
            case 'select':
            case "select_multiple":
                typeInput = 'select';
                break;
            case 'image':
                typeInput = 'mediaPicker';
                break;
            case 'file':
                typeInput = 'file';
                break;
            case 'date':
                typeInput = 'date';
                break;
            case 'switch':
                typeInput = 'switch';
                break;
            case "media_category":
                typeInput = 'selectTree';
                isMediaCategory = true
                break;
            default: typeInput = null;
        }

        return ({
            type: typeInput,
            label: langSelected?.node?.value ?? defaultLang?.node?.value,
            translated: true,
            handleMediaPicker:typeInput === 'mediaPicker' || typeInput === 'file' ? handleMediaPicker:null,
            allowedTypes:allowedTypes,
            helper: {
                text: '',
                link: false,
            },
            isSystem: false,
            currentLang,
            required: typeInput === 'mediaPicker' || variantGroup ? false : attribute.node.isRequired,
            stateName:  attribute.node.identifier,
            email: isEmail,
            bottom:isMediaCategory,
            translation:typeInput === "textarea"|| typeInput === "text"? true:false,
            valueWithFlags: true,
            multiselect:attribute.node.attributeType.input === "select_multiple",
            value:  typeInput === 'select'? attribute.node.attributeOptions?.edges.map((values) => {
                const langSelectedValuesDefault = values.node.translation.translationDatas.edges[0];

                const langSelectedValues = values.node.translation.translationDatas.edges.find(
                    lang  => lang.node.locale.code === currentLang
                );

                return ({
                    value: values.node.id,
                    label: langSelectedValues?.node.value ?? langSelectedValuesDefault?.node.value
                });
            }):allState?.[allState.currentLang]?.[attribute.node.identifier]||allState[attribute.node.identifier],
            data: isMediaCategory?(() => {
                let data = [];
                
                if (mediaCategories?.length > 0)
                    data = mediaCategories.filter(e => e.parent === null && e.node.libelle === 'Root').map(e => e.node);
                    data.unshift({id:null,checked:false,children:[],expanded:false,label:"Réinitialiser",value:null,libelle:"Réinitialiser"})
                let populateChildren = (cats, parent) => {
                    let catSelected = selectedMediaCategories
                    parent.value  = parent.id;
                    parent.label  = parent.libelle === 'Root' ? '/' : parent.libelle;
                    parent.disabled = false;
                    parent.children         = cats.filter(e => e.parent !== null && e.parent.id === parent.id).map(e => e.node);
                    parent.expanded         = true;
                    parent.checked   = parent.id ? catSelected === parent.id:false;

                    for (let child of parent.children)
                        populateChildren(cats, child);
                };

                for (let parent of data)
                    populateChildren(mediaCategories, parent);
                return data;
            })():[]
        });
    };

    let generalInputs = [
        {
            type: 'select',
            label: `Groupe d'attributs`,
            helper: {
                text: `Indiquez le groupe d'attributs`,
                link: false,
            },
            translated: false,
            required: false,
            disabled: true,
            stateName: 'groupAttribut',
            value: allGroups.map(group => {
                const langSelectedValuesDefault = group.node?.translation.translationDatas.edges[0];

                const langSelectedValues = group.node?.translation.translationDatas.edges.find(
                    lang  => lang.node.locale.code === currentLang
                );
                return ({
                    value: group.node?.id,
                    label: langSelectedValues?.node.value ?? langSelectedValuesDefault?.node.value ?? group.node?.identifier
                });
            })
        },
        {
            type: 'switch',
            label: 'Groupe d\'attributs configurable',
            helper: {
                label: 'État',
                text: 'Indiquez si le groupe d\'attributs est configurable',
                link: false,
            },
            required: true,
            stateName: 'isVariant',
            disabled: false,
            value: [
                {
                    value: true,
                    label: 'Oui',
                },
                {
                    value: false,
                    label: 'Non',
                },
            ]
        },
        {
            type: 'text',
            label: 'Code article',
            helper: {
                text: 'Code article du produit',
                link: false,
            },
            
            required: false,
            stateName: 'sku',
            disabled: true,
        },
        {
            type: 'text',
            label: 'EAN',
            helper: {
                text: 'Code EAN',
                link: false,
            },
            translated: true,
            required: false,
            stateName: 'product_ean',
            disabled: false,
            valueWithFlags: true,
        },
    ];

    if (hasPrice){
        generalInputs.push({
            type: 'decimal',
            label: 'Prix',
            helper: {
                text: 'Prix du produit',
                link: false,
            },
            translated: true,
            required: false,
            stateName: 'product_price',
            disabled: false,
            valueWithFlags: true,
        })
    }

    generalInputs.push({
        type: 'text',
        label: 'Titre du produit',
        helper: {
            text: 'Indiquez le nom du produit ici',
            link: false,
        },
        translated: true,
        required: true,
        stateName: 'product_name',
        valueWithFlags: true,
        checkSpelling:true,
        translation:true
    },
    {
        type: 'selectTree',
        label: 'Catégories',
        translated: false,
        helper: {
            text: 'Modifier les catégories du produit',
            link: false,
        },
        required: false,
        stateName: 'categories',
        multiselect: true,
        data: (() => {
            let data = categories.filter(e => e.parent === null);
            let populateChildren = (cats, parent) => {
                let catSelected = categoriesSelected.find(e => e.id === parent.id);

                let finalValue = parent.categoryDatas.edges.find(e => e.node.attribute.identifier === "category_name")?.node?.value || parent?.libelle;
                parent.value    = parent.id;
                parent.id    = parent.id;
                parent.label    = finalValue;
                parent.checked  = catSelected ? true : false;
                parent.expanded = false;
                parent.categoryStaticId = parent.id.replace('/api/categories/', '');
                parent.children = cats.filter(e => e.parent !== null && e.parent.id === parent.id);

                for (let child of parent.children)
                    populateChildren(cats, child);
            };

            for (let parent of data)
                populateChildren(categories, parent);

            return data;
        })()
    },
    {
        type: 'textarea',
        label: 'Description',
        helper: {
            text: 'Décrivez votre produit',
            link: false,
        },
        translated: true,
        required: false,
        stateName: 'product_description',
        valueWithFlags: true,
        richText:true,
        checkSpelling:true,
        translation:true
    },
    {
        type: 'buttonGroup',
        label: 'État',
        helper: {
            label: 'État',
            text: 'Indiquez l\'état',
            link: false,
        },
        required: false,
        stateName: 'status',
        value: [
            {
                value: true,
                label: 'Actif',
            },
            {
                value: false,
                label: 'Inactif',
            },
        ]
    })

    let shopifyInputs = allState.isSystemAttributes?.filter(e=>e.node.identifier.includes('shopify'))?.map(attributeSetup)

    if (shopifyInputs && shopifyInputs?.length > 0) {
        generalInputs.push(...shopifyInputs)
    }

    let isSystemInputs     = allState.isSystemAttributes?.filter(e=>!e.node.identifier.includes('mirakl')).map(attributeSetup)
    generalInputs.push(isSystemInputs)

    let imageInputs     = imageAttributes.map(attributeSetup);
    let metaInputs      = metaAttributes.map(attributeSetup); 
    // let customInputs    = customAttributes.filter(e => e.node.attributeType.input !== 'image' && e.node.status ).map(attributeSetup);
    let customInputs
    
    if (currentCollection === '/api/selections/3') {        
        customInputs    = customAttributes.filter(e => e.node.attributeType.input !== 'image' && e.node.status && e.node.identifier !== 'ecoresponsable').map(attributeSetup);
    }
    else if (currentCollection === '/api/selections/2') {        
        customInputs    = customAttributes.filter(e => e.node.attributeType.input !== 'image' && e.node.status && e.node.identifier !== 'personnal_shopper').map(attributeSetup);
    }
    else{        
        customInputs    = customAttributes.filter(e => e.node.attributeType.input !== 'image' && e.node.status&& e.node.identifier !== 'ecoresponsable'&& e.node.identifier !== 'personnal_shopper' ).map(attributeSetup);
    }
    
    let variantProduct    = [
        {
            type: 'variantAdd',
            required: false,
            stateName: 'variantsValidated',
            disabled: false,
            handleClick: handleToggleDrawer,
            hasPrice: hasPrice,
        }
    ]

    let hasErrors = (inputs) => {
        for (let input of inputs) {
            if (errors[input.stateName])
                return true;
        }
        return false;
    };

    var obj = {
        titleForm: 'Modifier le produit',
        subTitleForm: 'Veuillez compléter les champs ci-dessous pour modifier votre produit',
        langSelect: true,
        collectionSelect: true,
        drawerType: 'drawer',
        noForm: true,                
        component: Button,
        formConfig: {
            type: TABS,
            seeErrors,
            children:[
                {
                    labelName: 'Général',
                    optionsInputs: generalInputs
                },
                {
                    labelName: 'Médias ('+ (imagesSelected[0]?.original !== notFound && imagesSelected.length > 0 ? imagesSelected.length : 0 ) +'/' + imageAttributes.length + ')',
                    isOptionnal: true,
                    disabled: process.env.REACT_APP_PRODUCT_HIDE_SUGGESTIONS === 'true',
                    error: hasErrors(imageInputs),
                    optionsInputs: imageInputs
                },
                metaAttributes.length ? {
                    labelName: 'Métas',
                    isOptionnal: false,
                    disabled: process.env.REACT_APP_PRODUCT_HIDE_SUGGESTIONS === 'true',
                    error: hasErrors(metaInputs),
                    optionsInputs: metaInputs
                } : null,
                customInputs.length ? {
                    labelName: 'Attributs',
                    isOptionnal: false,
                    error: hasErrors(customInputs),
                    optionsInputs: customInputs
                } : null,
                {
                    labelName: 'Variantes',
                    isOptionnal: false,
                    disabled: !variantGroup,
                    error: hasErrors(variantProduct),
                    optionsInputs: variantProduct
                },
                {
                    labelName: 'Suggestions',
                    isOptionnal: true,
                    disabled: process.env.REACT_APP_PRODUCT_HIDE_SUGGESTIONS === 'true',
                    component: ProductsSelector,
                }
            ]
        }
    };

    return obj;
}